/* Version: 3.5.149 */
'use client';
// from RFC-4646: https://tools.ietf.org/html/rfc4646
var LANG = {
  EN_CA: 'en-CA',
  FR_CA: 'fr-CA'
};

export { LANG as default };
